import axios from "axios"; //引入axios
import Router from "@/router";
import { Message } from "element-ui";
import { MessageBox, Toast } from "mint-ui";
var baseURL = "https://mscyeserver.mscye.com/webstf.php/webStfapi";

// 使用promise返回axios请求的结果
export function get(url, params) {
  return new Promise((resolve, reject) => {
    var para = {
      city: localStorage.getItem("city") ? localStorage.getItem("city") : "上海"
    };

    if (params) {
      Object.assign(para, params);
    }
    axios
      .get(baseURL + url, {
        params: para,
        headers: {
          "Content-Type": "application/json",
          sessionToken: localStorage.getItem("sessionToken")
        }
      })
      .then(res => {
        if (res.data.status !== 1) {
          if (res.data.status == -999) {
            Toast("请登录");
            setTimeout(function() {
              Router.push({
                name: "login"
              });
            }, 2500);
          } else {
            Toast(res.data.msg);
          }
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    //console.log(params);
    var para = {
      city: localStorage.getItem("city") ? localStorage.getItem("city") : "上海"
    };

    if (params) {
      Object.assign(para, params);
    }
    axios
      .post(baseURL + url, para, {
        headers: {
          "Content-Type": "application/json",
          sessionToken: localStorage.getItem("sessionToken")
        }
      })
      .then(res => {
        if (res.data.status !== 1) {
          if (res.data.status == -999) {
            Toast("请登录");
            setTimeout(function() {
              Router.push({
                name: "login"
              });
            }, 2500);
          } else {
            Toast(res.data.msg);
          }
        }
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/view/http/http.js